// Modules
import { Component } from 'react'

const RELOAD_FLAG = 'chunkReloadAttempted'

const isChunkError = (err) =>
  err?.name === 'ChunkLoadError' ||
  /Loading chunk [\w\d]+ failed/i.test(err?.message || '') ||
  /Loading CSS chunk [\w\d]+ failed/i.test(err?.message || '')

class ErrorBoundary extends Component {
  state = { hasError: false, error: null }

  static getDerivedStateFromError(error) {
    if (isChunkError(error) && !sessionStorage.getItem(RELOAD_FLAG)) {
      sessionStorage.setItem(RELOAD_FLAG, '1')
      const url = new URL(window.location.href)
      url.searchParams.set('_r', Date.now())
      window.location.replace(url.toString())
      return { hasError: false, error: null }
    }
    return { hasError: true, error }
  }

  componentDidMount() {
    sessionStorage.removeItem(RELOAD_FLAG)
  }

  handleRetry = () => {
    sessionStorage.removeItem(RELOAD_FLAG)
    window.location.reload()
  }

  render() {
    if (!this.state.hasError) return this.props.children

    return (
      <div
        style={{
          padding: 24,
          minHeight: '100vh',
          fontFamily: 'sans-serif',
          color: '#fff',
          background: '#1A202C',
        }}
      >
        <h2 style={{ marginBottom: 12 }}>Failed to load the application</h2>
        <p style={{ marginBottom: 16, opacity: 0.8 }}>
          Possible causes: outdated browser cache after a site update, or an ad/script blocker.
          Try refreshing the page with cache cleared (Ctrl+Shift+R) or disable extensions for
          this site.
        </p>
        <button
          onClick={this.handleRetry}
          style={{
            padding: '10px 20px',
            background: '#3182ce',
            color: '#fff',
            border: 0,
            borderRadius: 4,
            cursor: 'pointer',
          }}
        >
          Try again
        </button>
      </div>
    )
  }
}

export default ErrorBoundary
